import React from "react";
import * as S from "./PoliticaPrivacidadeBanner.style";
import NavBar from "../NavBar/NavBar";
import useBreakpoints from "../../utils/useBreakpoints";

const PoliticaPrivacidadeBanner = () => {
  const { lg: desktop } = useBreakpoints();

  return (
    <>
      <S.Background desktop={desktop}>
        <S.Container>
          <S.Title desktop={desktop}>
            Proteger seus dados também é um jeito de cuidar de você.
          </S.Title>
          <S.Subtitle>
            Entenda como coletamos, cuidamos e armazenamos seus dados pessoais.
            Aqui você também pode personalizar os cookies e exercer o direito de
            controlar suas informações.
          </S.Subtitle>
        </S.Container>
      </S.Background>
      {desktop && <NavBar />}
    </>
  );
};

export default PoliticaPrivacidadeBanner;
